import { useIDEMode } from './ide/IdeMode';
import { EditMode } from './types';

export function useReadOnlyFlag() {
  const mode = useIDEMode();
  return mode === EditMode.disabled;
}
